// i18n.js
import { createI18n } from "vue-i18n";

// 导入语言文件
import jp from "./lang/jp";

const i18n = createI18n({
  locale: "jp", // 默认语言
  messages: {
    jp: jp,
  },
  allowComposition: true, // you need to specify that!
  legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
  globalInjection: true, // 全局注册$t方法
});

export default i18n;
